// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body::-webkit-scrollbar-track {
    background: #ea0000;
}
.app-container {
    display: flex;
    height: 100vh;
}

.main-content {
    flex: 1 1;
    overflow: hidden;
}

.unit-container {
    padding: 20px;
    height: calc(100vh - 64px);
    overflow-y: auto;
}

.breadcrumb {
    padding: 10px 0;
    margin-bottom: 20px;
    color: #666;
    font-size: 14px;
}

.content-wrapper {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
}

.content-wrapper.fullscreen {
    max-width: none;
    height: 100vh;
    background: white;
    z-index: 1000;
}

.content-item {
    margin-bottom: 30px;
}

.unit-title {
    font-size: 2rem;
    color: #333;
    margin-bottom: 1.5rem;
}

.section-title {
    font-size: 1.5rem;
    color: #444;
    margin-bottom: 1rem;
}

.content-paragraph {
    font-size: 1.1rem;
    line-height: 1.6;
    color: #555;
}

.pdf-container {
    width: 100%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    overflow: hidden;
    margin: 2rem 0;
    background: white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.pdf-page {
    margin: 20px auto;
}

.video-container {
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin: 2rem 0;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.video-player {
    width: 100%;
    max-height: 700px;
    object-fit: contain;
}

.image-container {
    width: 100%;
    text-align: center;
}

.content-image {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    cursor: pointer;
    transition: transform 0.3s ease;
}

.content-image:hover {
    transform: scale(1.02);
}

.fullscreen-toggle {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: #fff;
    border: none;
    /* box-shadow: 0 2px 8px rgba(0,0,0,0.2); */
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.loading-container,
.error-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 50vh;
}

.container {
    /* max-width: 1200px; */
    width: 100%;
    margin: 0 auto;
    padding: 20px;
    transition: all 0.3s ease;
    /* background-color: #fff; */
    /* box-shadow: 0 2px 20px rgba(0, 0, 0, 0.05); */
    border-radius: 12px;
}

.container.fullscreen {
    max-width: 100%;
    width: 100vw;
    height: 100vh;
    padding: 60px;
    /* background: #fff; */
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    overflow-y: auto;
}

/* Headings */
.unit-heading h1 {
    font-size: 26px;
    background-color: #273142;
    color: #bfbfbf;
    /* margin: 1.5rem 0; */
    font-weight: 600;
    padding: 15px 20px;
    border-radius: 8px;
    text-align: center;
}

.heading1 h1 {
    font-size: 22px;
    background-color: #273142;
    color: #bfbfbf !important;
    /* margin: 1.2rem 0; */
    font-weight: 500;
    padding: 12px 20px;
    border-radius: 6px;
    text-align: center;
}

.heading2 h2 {
    font-size: 20px;
    background-color: #273142;
    color: #bfbfbf !important;
    /* margin: 1rem 0; */
    font-weight: 500;
    padding: 10px 20px;
    border-radius: 6px;
    text-align: center;
}

/* Paragraphs */
.paragraph {
    /* margin: 1.2rem 0; */
    line-height: 1.8;
    color: #99adbf;
    font-size: 1.1rem;
    letter-spacing: 0.2px;
    /* padding: 0 20px; */
    /* max-width: 800px; */
    margin-left: auto;
    margin-right: auto;
}

/* Video Container */
video {
    width: 100%;
    max-height: 700px;
    object-fit: contain;
    background: #000;
}

/* Images */
.gallery {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    margin: 2rem 0;
    padding: 20px;
    width: 100%;
    /* background: #f8f9fa; */
    border-radius: 12px;
}

@media (max-width: 1200px) {
    .gallery {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 768px) {
    .gallery {
        grid-template-columns: repeat(2, 1fr);
    }
}

.gallery-item img {
    width: 100%;
    height: 280px;
    object-fit: cover;
    border-radius: 10px;
    cursor: pointer;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.gallery-item img:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

/* Image Popup */
.image-popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1100;
}

.image-popup img {
    max-width: 90%;
    max-height: 90vh;
    object-fit: contain;
}

.image-popup .close {
    position: absolute;
    top: 20px;
    right: 20px;
    color: white;
    font-size: 40px;
    cursor: pointer;
}

/* Fullscreen Button */
.fullscreen-button {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1200;
}

.fullscreen-button button {
    padding: 9px;
    background: #303f9f;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 500;
    font-size: 1.1rem;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.fullscreen-button button:hover {
    background: #1a237e;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
}

/* Loading State */
.loading {
    text-align: center;
    padding: 60px;
    font-size: 1.4rem;
    color: #303f9f;
    font-weight: 500;
}

/* Iframe containers */
.youtube-url,
.vimeo-url {
    margin: 2rem 0;
    position: relative;
    padding-bottom: 56.25%;
    /* 16:9 aspect ratio */
    height: 0;
    overflow: hidden;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.youtube-url iframe,
.vimeo-url iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.pdf-container {
    width: 100%;
    max-width: 100%;
    margin: 2rem auto;
    padding: 20px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.pdf-container .react-pdf__Document {
    width: 100% !important;
}

.pdf-container .react-pdf__Page {
    max-width: 100%;
    margin: 0 auto;
}

/* Updated Video and iframe containers */
.video-container,
.youtube-url,
.vimeo-url {
    width: 100%;
    max-width: 100%;
    margin: 2rem auto;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    padding-top: 56.25%;
    /* 16:9 Aspect Ratio */
}

.video-container video,
.youtube-url iframe,
.vimeo-url iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
}

/* Single Image Container */
.single-image-container {
    width: 100%;
    max-width: 100%;
    margin: 2rem auto;
    text-align: center;
}

.single-image-container img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
}

.content-section {
    position: relative;
    padding: 20px;
    margin-bottom: 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
}

.content-section:hover .section-controls {
    opacity: 1;
}

.section-controls {
    opacity: 0;
    transition: opacity 0.3s ease;
}

 .edit-container { 
    padding: 15px;
    border-radius: 4px;
    margin-top: 10px;
}


/* ...existing code... */

/* Add these styles for PDF canvas */
.react-pdf__Page canvas {
  width: 100% !important;
  height: auto !important;
  max-width: none !important;
}

.react-pdf__Page {
  display: flex;
  justify-content: center;
  width: 100% !important;
}

a {
    color: #677bff;
    text-decoration: none;
}

a:hover {
    color: #4cc3fa;
}`, "",{"version":3,"sources":["webpack://./src/components/Units/UnitView.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;IACxC,cAAc;IACd,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,2CAA2C;IAC3C,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,4BAA4B;IAC5B,gDAAgD;IAChD,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,gBAAgB;AACpB;;AAEA,aAAa;AACb;IACI,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,eAAe;AACf;IACI,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,cAAc;IACd,aAAa;IACb,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,qDAAqD;IACrD,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA,gBAAgB;AAChB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA,sBAAsB;AACtB;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;;IAEI,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;;IAEI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,wCAAwC;AACxC;;;IAGI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;;;IAGI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA,2BAA2B;AAC3B;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,6BAA6B;AACjC;;CAEC;IACG,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;;AAGA,wBAAwB;;AAExB,oCAAoC;AACpC;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB","sourcesContent":["body::-webkit-scrollbar-track {\n    background: #ea0000;\n}\n.app-container {\n    display: flex;\n    height: 100vh;\n}\n\n.main-content {\n    flex: 1;\n    overflow: hidden;\n}\n\n.unit-container {\n    padding: 20px;\n    height: calc(100vh - 64px);\n    overflow-y: auto;\n}\n\n.breadcrumb {\n    padding: 10px 0;\n    margin-bottom: 20px;\n    color: #666;\n    font-size: 14px;\n}\n\n.content-wrapper {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px;\n}\n\n.content-wrapper.fullscreen {\n    max-width: none;\n    height: 100vh;\n    background: white;\n    z-index: 1000;\n}\n\n.content-item {\n    margin-bottom: 30px;\n}\n\n.unit-title {\n    font-size: 2rem;\n    color: #333;\n    margin-bottom: 1.5rem;\n}\n\n.section-title {\n    font-size: 1.5rem;\n    color: #444;\n    margin-bottom: 1rem;\n}\n\n.content-paragraph {\n    font-size: 1.1rem;\n    line-height: 1.6;\n    color: #555;\n}\n\n.pdf-container {\n    width: 100%;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n    overflow: hidden;\n    margin: 2rem 0;\n    background: white;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.pdf-page {\n    margin: 20px auto;\n}\n\n.video-container {\n    width: 100%;\n    border-radius: 8px;\n    overflow: hidden;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    margin: 2rem 0;\n    border-radius: 12px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.video-player {\n    width: 100%;\n    max-height: 700px;\n    object-fit: contain;\n}\n\n.image-container {\n    width: 100%;\n    text-align: center;\n}\n\n.content-image {\n    max-width: 100%;\n    height: auto;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: transform 0.3s ease;\n}\n\n.content-image:hover {\n    transform: scale(1.02);\n}\n\n.fullscreen-toggle {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    background: #fff;\n    border: none;\n    /* box-shadow: 0 2px 8px rgba(0,0,0,0.2); */\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n.loading-container,\n.error-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 50vh;\n}\n\n.container {\n    /* max-width: 1200px; */\n    width: 100%;\n    margin: 0 auto;\n    padding: 20px;\n    transition: all 0.3s ease;\n    /* background-color: #fff; */\n    /* box-shadow: 0 2px 20px rgba(0, 0, 0, 0.05); */\n    border-radius: 12px;\n}\n\n.container.fullscreen {\n    max-width: 100%;\n    width: 100vw;\n    height: 100vh;\n    padding: 60px;\n    /* background: #fff; */\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 1000;\n    overflow-y: auto;\n}\n\n/* Headings */\n.unit-heading h1 {\n    font-size: 26px;\n    background-color: #273142;\n    color: #bfbfbf;\n    /* margin: 1.5rem 0; */\n    font-weight: 600;\n    padding: 15px 20px;\n    border-radius: 8px;\n    text-align: center;\n}\n\n.heading1 h1 {\n    font-size: 22px;\n    background-color: #273142;\n    color: #bfbfbf !important;\n    /* margin: 1.2rem 0; */\n    font-weight: 500;\n    padding: 12px 20px;\n    border-radius: 6px;\n    text-align: center;\n}\n\n.heading2 h2 {\n    font-size: 20px;\n    background-color: #273142;\n    color: #bfbfbf !important;\n    /* margin: 1rem 0; */\n    font-weight: 500;\n    padding: 10px 20px;\n    border-radius: 6px;\n    text-align: center;\n}\n\n/* Paragraphs */\n.paragraph {\n    /* margin: 1.2rem 0; */\n    line-height: 1.8;\n    color: #99adbf;\n    font-size: 1.1rem;\n    letter-spacing: 0.2px;\n    /* padding: 0 20px; */\n    /* max-width: 800px; */\n    margin-left: auto;\n    margin-right: auto;\n}\n\n/* Video Container */\nvideo {\n    width: 100%;\n    max-height: 700px;\n    object-fit: contain;\n    background: #000;\n}\n\n/* Images */\n.gallery {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 20px;\n    margin: 2rem 0;\n    padding: 20px;\n    width: 100%;\n    /* background: #f8f9fa; */\n    border-radius: 12px;\n}\n\n@media (max-width: 1200px) {\n    .gallery {\n        grid-template-columns: repeat(3, 1fr);\n    }\n}\n\n@media (max-width: 768px) {\n    .gallery {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n.gallery-item img {\n    width: 100%;\n    height: 280px;\n    object-fit: cover;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n.gallery-item img:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n}\n\n/* Image Popup */\n.image-popup {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.9);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1100;\n}\n\n.image-popup img {\n    max-width: 90%;\n    max-height: 90vh;\n    object-fit: contain;\n}\n\n.image-popup .close {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    color: white;\n    font-size: 40px;\n    cursor: pointer;\n}\n\n/* Fullscreen Button */\n.fullscreen-button {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    z-index: 1200;\n}\n\n.fullscreen-button button {\n    padding: 9px;\n    background: #303f9f;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-weight: 500;\n    font-size: 1.1rem;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n}\n\n.fullscreen-button button:hover {\n    background: #1a237e;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);\n}\n\n/* Loading State */\n.loading {\n    text-align: center;\n    padding: 60px;\n    font-size: 1.4rem;\n    color: #303f9f;\n    font-weight: 500;\n}\n\n/* Iframe containers */\n.youtube-url,\n.vimeo-url {\n    margin: 2rem 0;\n    position: relative;\n    padding-bottom: 56.25%;\n    /* 16:9 aspect ratio */\n    height: 0;\n    overflow: hidden;\n    border-radius: 12px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.youtube-url iframe,\n.vimeo-url iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n.pdf-container {\n    width: 100%;\n    max-width: 100%;\n    margin: 2rem auto;\n    padding: 20px;\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.pdf-container .react-pdf__Document {\n    width: 100% !important;\n}\n\n.pdf-container .react-pdf__Page {\n    max-width: 100%;\n    margin: 0 auto;\n}\n\n/* Updated Video and iframe containers */\n.video-container,\n.youtube-url,\n.vimeo-url {\n    width: 100%;\n    max-width: 100%;\n    margin: 2rem auto;\n    border-radius: 8px;\n    overflow: hidden;\n    position: relative;\n    padding-top: 56.25%;\n    /* 16:9 Aspect Ratio */\n}\n\n.video-container video,\n.youtube-url iframe,\n.vimeo-url iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: none;\n}\n\n/* Single Image Container */\n.single-image-container {\n    width: 100%;\n    max-width: 100%;\n    margin: 2rem auto;\n    text-align: center;\n}\n\n.single-image-container img {\n    max-width: 100%;\n    height: auto;\n    border-radius: 8px;\n}\n\n.content-section {\n    position: relative;\n    padding: 20px;\n    margin-bottom: 20px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n}\n\n.content-section:hover .section-controls {\n    opacity: 1;\n}\n\n.section-controls {\n    opacity: 0;\n    transition: opacity 0.3s ease;\n}\n\n .edit-container { \n    padding: 15px;\n    border-radius: 4px;\n    margin-top: 10px;\n}\n\n\n/* ...existing code... */\n\n/* Add these styles for PDF canvas */\n.react-pdf__Page canvas {\n  width: 100% !important;\n  height: auto !important;\n  max-width: none !important;\n}\n\n.react-pdf__Page {\n  display: flex;\n  justify-content: center;\n  width: 100% !important;\n}\n\na {\n    color: #677bff;\n    text-decoration: none;\n}\n\na:hover {\n    color: #4cc3fa;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
